import React from 'react';

import { neptuneUrls } from '@neptune/shared/common-domain';
import { onlineConnectionService } from '@neptune/shared/core-connection-domain';
import { Button, Layout, Link, Text } from '@neptune/shared/venus-ui';

import { ContactSupport } from '../contact-support/ContactSupport';

import { ErrorPage } from './ErrorPage';

export const AppInitErrorPage = () => {
  const isConnectivityIssue = !onlineConnectionService.isOnline;
  const message = isConnectivityIssue ? (
    <Layout.Column spacedChildren="sm">
      <Layout.Row alignItems="center" justifyContent="center">
        Neptune can&apos;t reach the server from your browser. Check your internet connection and
        try again.
      </Layout.Row>
      <Layout.Row alignItems="center" justifyContent="center">
        <Button<React.ComponentProps<typeof Link>>
          href={neptuneUrls.speedTest}
          component={Link}
          variant="transparent"
          external
        >
          Run connection test
        </Button>
      </Layout.Row>
    </Layout.Column>
  ) : (
    <>
      We&apos;re fixing the problem so please
      <Text fontWeight="bold"> try again in a few minutes</Text>
    </>
  );

  return (
    <ErrorPage>
      <ErrorPage.Title>
        {isConnectivityIssue ? 'Connection problem' : 'Something went wrong :('}
      </ErrorPage.Title>
      <ErrorPage.Message>{message}</ErrorPage.Message>
      <ErrorPage.Footer>
        {isConnectivityIssue ? (
          <>
            If the connection test passes and the problem still occurs,{' '}
            <ContactSupport>contact us</ContactSupport>.
          </>
        ) : (
          <>
            If the problem still occurs, <ContactSupport>contact us</ContactSupport>.
          </>
        )}
      </ErrorPage.Footer>
    </ErrorPage>
  );
};
